$(document).ready(function(){

  if ($("#cropMap").length){

    var map = new mapboxgl.Map({
      container: 'cropMap', // container element id
      style: 'mapbox://styles/mapbox/dark-v9',
      center: {lat: 41.6005448, lng: -93.6091064},
      zoom: 4,
    });


    map.on('load', function() {


      var mapData = JSON.parse($("#mapjson").val());

      map.addLayer({
        'id': 'percentage',
        'type': 'fill',
        'source': {
          'type': 'geojson',
          'data': mapData
        },
        'paint': {
          'fill-opacity': 0.8,
          'fill-outline-color': 'rgba(0,0,0,1)',
          'fill-color': [
            'step',
            ['get', 'LossPercentage'],
            $('#percentageRangeStepDefault').val(),
            parseFloat($('#percentageRangeStep1').val()), $('#percentageRangeStep1Color').val(),
            parseFloat($('#percentageRangeStep2').val()), $('#percentageRangeStep2Color').val(),
            parseFloat($('#percentageRangeStep3').val()), $('#percentageRangeStep3Color').val(),
            parseFloat($('#percentageRangeStep4').val()), $('#percentageRangeStep4Color').val(),
            parseFloat($('#percentageRangeStep5').val()), $('#percentageRangeStep5Color').val(),
            parseFloat($('#percentageRangeStep6').val()), $('#percentageRangeStep6Color').val(),
            parseFloat($('#percentageRangeStep7').val()), $('#percentageRangeStep7Color').val(),
            parseFloat($('#percentageRangeStep8').val()), $('#percentageRangeStep8Color').val(),
            parseFloat($('#percentageRangeStep9').val()), $('#percentageRangeStep9Color').val(),
          ],
        }
      });

      map.setFilter('percentage', ['==', ['number', ['get', 'Year']], parseInt($("#slider").val())]);

      map.addLayer({
        'id': 'bushels',
        'type': 'fill',
        'source': {
          'type': 'geojson',
          'data': mapData
        },
        'paint': {
          'fill-opacity': 0,
          'fill-outline-color': 'rgba(0,0,0,1)',
          'fill-color': [
            'step',
            ['get', 'LossBushels'],
            $('#bushelsRangeStepDefault').val(),
            parseFloat($('#bushelsRangeStep1').val()), $('#bushelsRangeStep1Color').val(),
            parseFloat($('#bushelsRangeStep2').val()), $('#bushelsRangeStep2Color').val(),
            parseFloat($('#bushelsRangeStep3').val()), $('#bushelsRangeStep3Color').val(),
            parseFloat($('#bushelsRangeStep4').val()), $('#bushelsRangeStep4Color').val(),
            parseFloat($('#bushelsRangeStep5').val()), $('#bushelsRangeStep5Color').val(),
            parseFloat($('#bushelsRangeStep6').val()), $('#bushelsRangeStep6Color').val(),
            parseFloat($('#bushelsRangeStep7').val()), $('#bushelsRangeStep7Color').val(),
            parseFloat($('#bushelsRangeStep8').val()), $('#bushelsRangeStep8Color').val(),
            parseFloat($('#bushelsRangeStep9').val()), $('#bushelsRangeStep9Color').val(),
          ],
        }
      });

      map.setFilter('bushels', ['==', ['number', ['get', 'Year']], parseInt($("#slider").val())]);

      map.addLayer({
        'id': 'dollars',
        'type': 'fill',
        'source': {
          'type': 'geojson',
          'data': mapData
        },
        'paint': {
          'fill-opacity': 0,
          'fill-outline-color': 'rgba(0,0,0,1)',
          'fill-color': [
            'step',
            ['get', 'LossDollars'],
            $('#dollarsRangeStepDefault').val(),
            parseFloat($('#dollarsRangeStep1').val()), $('#dollarsRangeStep1Color').val(),
            parseFloat($('#dollarsRangeStep2').val()), $('#dollarsRangeStep2Color').val(),
            parseFloat($('#dollarsRangeStep3').val()), $('#dollarsRangeStep3Color').val(),
            parseFloat($('#dollarsRangeStep4').val()), $('#dollarsRangeStep4Color').val(),
            parseFloat($('#dollarsRangeStep5').val()), $('#dollarsRangeStep5Color').val(),
            parseFloat($('#dollarsRangeStep6').val()), $('#dollarsRangeStep6Color').val(),
            parseFloat($('#dollarsRangeStep7').val()), $('#dollarsRangeStep7Color').val(),
            parseFloat($('#dollarsRangeStep8').val()), $('#dollarsRangeStep8Color').val(),
            parseFloat($('#dollarsRangeStep9').val()), $('#dollarsRangeStep9Color').val(),
          ],
        }
      });

      map.setFilter('dollars', ['==', ['number', ['get', 'Year']], parseInt($("#slider").val())]);

      map.addLayer({
        'id': 'peracre',
        'type': 'fill',
        'source': {
          'type': 'geojson',
          'data': mapData
        },
        'paint': {
          'fill-opacity': 0,
          'fill-outline-color': 'rgba(0,0,0,1)',
          'fill-color': [
            'step',
            ['get', 'LossPerAcre'],
            $('#perAcreRangeStepDefault').val(),
            parseFloat($('#perAcreRangeStep1').val()), $('#perAcreRangeStep1Color').val(),
            parseFloat($('#perAcreRangeStep2').val()), $('#perAcreRangeStep2Color').val(),
            parseFloat($('#perAcreRangeStep3').val()), $('#perAcreRangeStep3Color').val(),
            parseFloat($('#perAcreRangeStep4').val()), $('#perAcreRangeStep4Color').val(),
            parseFloat($('#perAcreRangeStep5').val()), $('#perAcreRangeStep5Color').val(),
            parseFloat($('#perAcreRangeStep6').val()), $('#perAcreRangeStep6Color').val(),
            parseFloat($('#perAcreRangeStep7').val()), $('#perAcreRangeStep7Color').val(),
            parseFloat($('#perAcreRangeStep8').val()), $('#perAcreRangeStep8Color').val(),
            parseFloat($('#perAcreRangeStep9').val()), $('#perAcreRangeStep9Color').val(),
          ],
        }
      });

      map.setFilter('peracre', ['==', ['number', ['get', 'Year']], parseInt($("#slider").val())]);


      // Year changer
      document.getElementById('slider').addEventListener('input', function(e) {
        var year = parseInt(e.target.value);

        // update the map
        map.setFilter('percentage', ['==', ['number', ['get', 'Year']], year]);
        map.setFilter('bushels', ['==', ['number', ['get', 'Year']], year]);
        map.setFilter('dollars', ['==', ['number', ['get', 'Year']], year]);
        map.setFilter('peracre', ['==', ['number', ['get', 'Year']], year]);

        // update text in the UI
        document.getElementById('active-year').innerText = year;
      });

      // Type changer
      $('input[name="type"]').on('change', function(e) {

        // Hide all Layers
        map.setPaintProperty('percentage','fill-opacity',0);
        map.setPaintProperty('bushels','fill-opacity',0);
        map.setPaintProperty('dollars','fill-opacity',0);
        map.setPaintProperty('peracre','fill-opacity',0);
        $(".color-legend").hide();


        // Show the selected layer
        map.setPaintProperty($(this).val(),'fill-opacity',0.8);
        $("#color-legend-"+$(this).val()).show();

      });



      map.on('click', 'percentage', function(e) {
        // Change the cursor style as a UI indicator.
        //map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.Description;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // Populate the popup and set its coordinates based on the feature found.
        new mapboxgl.Popup().setLngLat(e.lngLat).setHTML(description).addTo(map);

      });

      // Change the cursor to a pointer when the mouse is over the places layer.
      map.on('mouseenter', 'places', function() {
      map.getCanvas().style.cursor = 'pointer';
      });

      // Change it back to a pointer when it leaves.
      map.on('mouseleave', 'places', function() {
      map.getCanvas().style.cursor = '';
      });

    });

  }

});



// WEBPACK FOOTER //
// ./resources/assets/js/public/crop-map.js